import React, { useEffect, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { useRtl } from './useRtl';
var RTLProvider = function RTLProvider(_ref) {
  var _ref$rtlLanguageCodes = _ref.rtlLanguageCodes,
    rtlLanguageCodes = _ref$rtlLanguageCodes === void 0 ? ['ar'] : _ref$rtlLanguageCodes,
    children = _ref.children;
  var _useRtl = useRtl(rtlLanguageCodes),
    isRTL = _useRtl.isRTL,
    dir = _useRtl.dir;
  var cacheRtl = useMemo(function () {
    return createCache({
      key: isRTL ? 'muirtl' : 'muiltr',
      stylisPlugins: isRTL ? [prefixer, rtlPlugin] : []
    });
  }, [isRTL]);
  useEffect(function () {
    document.body.setAttribute('dir', dir);
  }, [dir]);
  var theme = createTheme({
    direction: dir
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(CacheProvider, {
    value: cacheRtl
  }, children));
};
export { RTLProvider };